export function normalizeTimestampToMs(value: unknown): number | null {
  if (value == null) return null;

  if (typeof value === 'string') {
    const s = value.trim();
    if (!s) return null;

    const n = Number(s);
    if (Number.isFinite(n)) return n < 1e11 ? n * 1000 : n;

    const parsed = Date.parse(s);
    if (!Number.isFinite(parsed)) return null;
    return parsed;
  }

  const asNum = Number(value);
  if (!Number.isFinite(asNum)) return null;
  if (asNum < 1e11) return asNum * 1000;
  return asNum;
}
